// Mirrors server TachographStatus (SuperTacho.DataModel/TachographChartImport/TachographStatus.cs).
export const TACHOGRAPH_STATUSES: { value: number; key: string; def: string }[] = [
  { value: 0, key: 'statusNone', def: 'Brak' },
  { value: 1, key: 'statusAETR', def: 'AETR' },
  { value: 2, key: 'statusNoActivity', def: 'Brak aktywności' },
  { value: 3, key: 'statusNoRecords', def: 'Brak zapisów' },
  { value: 4, key: 'statusToFix', def: 'Do poprawy' },
  { value: 5, key: 'statusToClarify', def: 'Do wyjaśnienia' },
  { value: 6, key: 'statusViolations', def: 'Naruszenia' },
  { value: 7, key: 'statusUnreadable', def: 'Nieczytelna' },
  { value: 8, key: 'statusOut', def: 'OUT' },
  { value: 9, key: 'statusService', def: 'Serwis' },
]
